import { Injectable, InjectionToken, inject } from '@angular/core';
import type { NavSection } from '../models/nav-section.model';

export type AppName = 'merchant' | 'settlement';
export const APP_NAME = new InjectionToken<AppName>('APP_NAME');
export const APP_NAV_SECTIONS = new InjectionToken<NavSection[]>('APP_NAV_SECTIONS', { factory: () => [] });

@Injectable({ providedIn: 'root' })
export class AppContextService {
  private readonly appName = inject<AppName>(APP_NAME);
  private readonly navSections = inject(APP_NAV_SECTIONS);

  getAppName(): AppName {
    return this.appName;
  }

  getNavSections(): NavSection[] {
    return this.navSections;
  }
}
